import { s } from './icon.style'
import React from 'react'
import type { IconProps } from '../iconProps'

export const DropdownArrowUpFillIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="20"
          y="20"
          width="20"
          height="20"
          rx="4"
          transform="rotate(-180 20 20)"
          fill="#212121"
        />
        <path
          d="M13.419 12.5C14.3099 12.5 14.7561 11.4229 14.1261 10.7929L10.707 7.37377C10.3165 6.98325 9.68334 6.98325 9.29281 7.37377L5.87369 10.7929C5.24373 11.4229 5.68989 12.5 6.5808 12.5L13.419 12.5Z"
          fill="white"
        />
      </svg>
    )
  }
)
